import { render, staticRenderFns } from "./consumebook.vue?vue&type=template&id=5c51ad27&scoped=true&"
import script from "./consumebook.vue?vue&type=script&lang=js&"
export * from "./consumebook.vue?vue&type=script&lang=js&"
import style0 from "./consumebook.vue?vue&type=style&index=0&id=5c51ad27&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c51ad27",
  null
  
)

export default component.exports